var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c(
        "div",
        { staticClass: "collapse-btn", on: { click: _vm.collapseChage } },
        [
          _c("img", {
            attrs: { src: require("@/assets/img/menu.png"), alt: "" },
          }),
        ]
      ),
      _vm.showbc
        ? _c(
            "el-breadcrumb",
            {
              staticClass: "breadcrumb-container",
              attrs: { "separator-class": "el-icon-arrow-right" },
            },
            _vm._l(_vm.levelList, function (item) {
              return _c("el-breadcrumb-item", { key: item.path }, [
                _vm._v(_vm._s(_vm.$t(item.meta.title))),
              ])
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }